import { CheckCircle2Icon, PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button/ButtonGroup';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderSectionAppendPopover() {
  const { appendSection } = useQuizBuilder();
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<string | undefined>(undefined);

  const onValueChange = (newValue: string) => {
    setValue(newValue);
  };

  const onSubmit = () => {
    appendSection(value);
    setOpen(false);
    setValue(undefined);
    toast.success('Dodano nową sekcję quizu', { duration: 1500, closeButton: false, position: 'top-center' });
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant={'outline'} size={'sm'}>
          <PlusIcon />
          Dodaj sekcję
        </Button>
      </PopoverTrigger>
      <PopoverContent className="border-0 p-0 shadow-lg" align="end">
        <ButtonGroup>
          <Input
            className="flex-1 focus:z-10"
            placeholder="Nazwa sekcji"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSubmit();
              }
            }}
          />

          <Button variant={'outline'} onClick={onSubmit}>
            <CheckCircle2Icon />
            Zatwierdź
          </Button>
        </ButtonGroup>
      </PopoverContent>
    </Popover>
  );
}
